type ShowEmptyParameters = {
	areCustomFieldsReady: boolean;
	isViewModeList: boolean;
	isExportMode: boolean;
	isConfluenceMacro: boolean;
	totalVisibleColumns: number;
};

/* The fields empty view is shown under quite specific circumstances.
 * It was extracted into a utility so it could be easily tested in isolation.
 */
export const showEmptyView = ({
	areCustomFieldsReady,
	isViewModeList,
	isExportMode,
	isConfluenceMacro,
	totalVisibleColumns,
}: ShowEmptyParameters) => {
	const isValidEnvironment = isViewModeList && !isConfluenceMacro && !isExportMode;
	return isValidEnvironment && areCustomFieldsReady && totalVisibleColumns === 0;
};
